<div class="modal-content">
    <!-- Cabeçalho do Modal com título e botão de fechar -->
    <div class="modal-header">
      <h5 class="modal-title">
        Atualizar Status Documento
      </h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Fechar"
        (click)="activeModal.dismiss()"
      ></button>
    </div>
  
    <div class="modal-body p-4">
      <form [formGroup]="documentoForm" (ngSubmit)="AtualizarDocumento()">

        <input hidden formControlName="projetoId">
        <input hidden formControlName="documentoId">
        <input hidden formControlName="tipoDocumento">

        <div class="mb-3">
            <label for="statusProjeto" class="form-label">
              Selecione o status
            </label><span style="color: red;">*</span>
            <select class="form-select" formControlName="statusDocumento" 
            [ngClass]="{
              'is-invalid':
              documentoForm.controls.statusDocumento.errors &&
              documentoForm.get('statusDocumento')?.touched,
            }"
            >
              <option value="" selected disabled>Selecione um status</option>
              <!-- <option value="0">Briefing</option> -->
              <option value="0">Iniciado</option>
              <option value="1">Aprovado</option>
              <option value="2">Reprovado</option>
              <option value="3">Cancelado</option>
              <option value="4">Orçando</option>
              <option value="5">E-mail enviado</option>
              <option value="6">Assinatura Solicitada</option>
              <option value="7">Assinatura Concluída</option>
              <option value="8">Cancelado Assinatura</option>
            </select>
            <div class="invalid-feedback" *ngIf="documentoForm.controls.statusDocumento.errors">
              Selecione um status
            </div>
          </div>
        <!-- Botão de Enviar -->
        <div class="text-end">
          @if(!isLoading){

            <button type="submit" class="btn btn-success btn-sm w-md">
              Atualizar
            </button>
          }@else{
            <button type="button" class="btn btn-light waves-effect">
              <i class="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i> Trabalhando
          </button>
          }
        </div>
      </form>
    </div>
  </div>
  